import useSWR from "swr";
import { fetcher } from "../../../../services/fetcher";
import DataWrapper from "../../../../common/components/DataWrapper/DataWrapper";
import { Stack, Text, Badge } from "@mantine/core";
import MainLoader from "../../../../common/components/Loader/Loader";

const ENDPOINT = "operator/account-expiry/";

const statusBadge = (isActive) => (
  <Badge color={isActive ? "green" : "red"} variant="light">
    {isActive ? "Active" : "Inactive"}
  </Badge>
);

const mapRows = (rows = []) =>
  rows.map((item) => ({
    operator_unique_code: item.operator_unique_code ?? "—",
    name: item.name ?? "—",
    email: item.email ?? "—",
    account_created_on: item.account_created_on ?? "—",
    account_valid_till: item.account_valid_till ?? "—",
    is_active: statusBadge(item.is_active),
  }));

const config = {
  fields: [
    { key: "operator_unique_code", label: "Unique Code" },
    { key: "name", label: "Name" },
    { key: "email", label: "Email" },
    { key: "account_created_on", label: "Created On" },
    { key: "account_valid_till", label: "Valid Till" },
    { key: "is_active", label: "Status", type: "custom" },
  ],
};

const AccountExpiry = () => {
  const { data, error, isLoading } = useSWR(ENDPOINT, fetcher, {
    revalidateOnFocus: false,
  });

  if (isLoading) return <MainLoader />;
  if (error) return <Text c="red">Failed to load account expiry data.</Text>;

  const expiredRows = data?.expired?.results ?? [];
  const expiringSoonRows = data?.expiring_soon?.results ?? [];

  return (
    <Stack gap={32}>
      <Stack gap={8} ml="lg">
        <Text fw={600} fz={16} c="#092C4C">
          Expired ({data?.expired?.count ?? 0})
        </Text>
        <DataWrapper rows={mapRows(expiredRows)} config={config} />
      </Stack>

      <Stack gap={8} ml="lg">
        <Text fw={600} fz={16} c="#092C4C">
          Expiring Soon — next {data?.days ?? 7} days ({data?.expiring_soon?.count ?? 0})
        </Text>
        <DataWrapper rows={mapRows(expiringSoonRows)} config={config} />
      </Stack>
    </Stack>
  );
};

export default AccountExpiry;
